import { isRefusedByPartialPasskeySupport } from '../../utils/passkeySupportUtils';

export const getPasskeyAuthenticationErrorType = async (error) => {
  if (error.name !== 'NotAllowedError') {
    return 'PASSKEY_AUTHENTICATION_FAILED';
  }

  return (await isRefusedByPartialPasskeySupport(error))
    ? 'PASSKEY_PARTIAL_SUPPORT_EXCEPTION'
    : 'NOT_ALLOWED_PASSKEY_EXCEPTION';
};
